"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));
var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactIntl = require("react-intl");
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _billingFormFields = require("./billingFormFields");
var _templateObject;
var ValidationErrorsContainer = _styledComponents["default"].span(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2["default"])(["\n  color: #cc0023;\n  display: block;\n  font-family: 'Square Sans Text VF', 'Square Sans Text', Arial, sans-serif;\n  font-size: 14px;\n  margin: 11px 0;\n  width: 100%;\n\n  &::before {\n    background-color: #cc0023;\n    content: \" __\";\n    margin-right: 10px;\n    mask: url(\"data:image/svg+xml,%3Csvg width=%2716%27 height=%2716%27 viewBox=%270 0 16 16%27 xmlns=%27http://www.w3.org/2000/svg%27%3E%3Cpath fill-rule=%27evenodd%27 clip-rule=%27evenodd%27 d=%27M16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16C12.4183 16 16 12.4183 16 8ZM8 9C8.55229 9 9 8.55228 9 8V5C9 4.44771 8.55229 4 8 4C7.44772 4 7 4.44771 7 5V8C7 8.55228 7.44772 9 8 9ZM8 10C8.55229 10 9 10.4477 9 11C9 11.5523 8.55229 12 8 12C7.44772 12 7 11.5523 7 11C7 10.4477 7.44772 10 8 10Z%27/%3E%3C/svg%3E\");\n    -webkit-mask: url(\"data:image/svg+xml,%3Csvg width=%2716%27 height=%2716%27 viewBox=%270 0 16 16%27 xmlns=%27http://www.w3.org/2000/svg%27%3E%3Cpath fill-rule=%27evenodd%27 clip-rule=%27evenodd%27 d=%27M16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16C12.4183 16 16 12.4183 16 8ZM8 9C8.55229 9 9 8.55228 9 8V5C9 4.44771 8.55229 4 8 4C7.44772 4 7 4.44771 7 5V8C7 8.55228 7.44772 9 8 9ZM8 10C8.55229 10 9 10.4477 9 11C9 11.5523 8.55229 12 8 12C7.44772 12 7 11.5523 7 11C7 10.4477 7.44772 10 8 10Z%27/%3E%3C/svg%3E\");\n  }\n\n"])));
var ValidationErrors = function ValidationErrors(_ref) {
  var errors = _ref.errors,
    provider = _ref.provider,
    touched = _ref.touched;
  var _useIntl = (0, _reactIntl.useIntl)(),
    formatMessage = _useIntl.formatMessage;
  var errorsFieldsIds = Object.keys(errors);
  var haveNoErrors = errorsFieldsIds.reduce(function (acc, key) {
    return acc && errors[key] === undefined;
  }, true);
  if (haveNoErrors) return null;
  var untouched = Object.keys(touched).reduce(function (acc, key) {
    return acc && touched[key] === false;
  }, true);
  if (untouched) return null;
  var topErrorField = errorsFieldsIds[0];
  var labelId = (0, _typeof2["default"])(_billingFormFields.BILLING_FORM_FIELDS_DEF[topErrorField].labelId) === 'object' ? _billingFormFields.BILLING_FORM_FIELDS_DEF[topErrorField].labelId[provider] : _billingFormFields.BILLING_FORM_FIELDS_DEF[topErrorField].labelId;
  return _react["default"].createElement(ValidationErrorsContainer, null, formatMessage({
    id: labelId
  }), "\xA0", formatMessage({
    id: errors[topErrorField].message
  }, {
    value: errors[topErrorField].value
  }));
};
var _default = exports["default"] = ValidationErrors;